import React from 'react';
import './environment-indicator.scss';

const EnvironmentIndicator = () => {
  // Fail-closed: default to Production (hidden) if env var not set
  const environment = process.env.REACT_APP_ENVIRONMENT || 'Production';

  // Only show for explicitly set non-production environments
  if (environment === 'Production') {
    return null;
  }

  return (
    <div className={`environment-indicator environment-${environment.toLowerCase()}`}>
      {environment}
    </div>
  );
};

export default EnvironmentIndicator;
